import Component from "../../component";

export const RewardsLauncherTogglerConfig = {
    signature: 'rewardsLauncherToggler',
    baseHtmlClass: 'rewards_launcher_toggler',
    selector: '.rewards_launcher_toggler',
    initedHtmlClass: 'rewards_launcher_toggler--inited',
    initedHtmlClassModifier: 'inited',
};

export class RewardsLauncherToggler extends Component {

    static applyToAll(toggleFunction) {
        document.querySelectorAll(RewardsLauncherTogglerConfig.selector).forEach((element) => {
            if (RewardsLauncherToggler.isElementComponentized(element, RewardsLauncherTogglerConfig.signature)) return;
            new RewardsLauncherToggler(element, toggleFunction);
        });
    }

    constructor(id_or_element, toggleFunction, props = {}) {
        super({
            element: id_or_element,
            config: RewardsLauncherTogglerConfig
        });

        // The function to call to toggle the rewards launcher UI visibility.
        this.toggleFunction = toggleFunction || this.fallbackToggleFunction;

        this.element.addEventListener('click', this.handleClick.bind(this));

        this.inited = true;
        this.render();
    }

    handleClick(event) {
        event.preventDefault();
        this.toggleFunction();
    }

    fallbackToggleFunction() {
        console.warn(`[${RewardsLauncherTogglerConfig.signature}] No toggleFunction provided`);
    }

    render() {
        this.conditionallySetHtmlClassState(this.inited, RewardsLauncherTogglerConfig.initedHtmlClassModifier);
    }

}
